import { render, staticRenderFns } from "./VaccinationInfo.vue?vue&type=template&id=0ecf98e3&"
import script from "./VaccinationInfo.vue?vue&type=script&lang=js&"
export * from "./VaccinationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports